import('jsxgraph').then(JXG => {

    var liste=[];
    var stackliste=[];

    JXG.Options.point.snapToGrid = true;
    JXG.Options.point.snapSizeX = 1;
    JXG.Options.point.snapSizeY = 0.01;
    JXG.Options.point.withLabel = false;
    JXG.Options.point.fixed = true;
    JXG.Options.line.fixed = true;


    var getMouseCoords = function(e, i) {
	var cPos = board.getCoordsTopLeftCorner(e, i),
	    absPos = JXG.getPosition(e, i),
	    dx = absPos[0]-cPos[0],
	    dy = absPos[1]-cPos[1];

	return new JXG.Coords(JXG.COORDS_BY_SCREEN, [dx, dy], board);
    },
	down = function(e) {
	    var canCreate = true, i, coords, el;

	    if (e[JXG.touchProperty]) {
		// index of the finger that is used to extract the coordinates
		i = 0;
	    }
	    coords = getMouseCoords(e, i);

	    for (el in board.objects) {
		if(JXG.isPoint(board.objects[el]) && board.objects[el].hasPoint(coords.scrCoords[1], coords.scrCoords[2])) {
		    canCreate = false;
		    //console.log("punkt vorhanden");
		    for (r in liste){
			//console.log(liste[r]);
			if(board.objects[el].X()==liste[r][0].X() && board.objects[el].Y()==liste[r][0].Y()){
			    //console.log(liste);
			    
			    //board.removeObject(board.objects[el]);
			    board.removeObject(liste[r]);
			    delete liste[r];
			    liste=liste.filter(Boolean);
			    //stackliste=liste.map(x=>[x[0].X(),x[0].Y()]);
			    stackliste=liste.map(x=>"["+x[0].X()+","+x[0].Y()+"]").join();
			    break;
			}
		    }
		    break;
		}
	    }

	    if (canCreate) {
		p=board.create('point', [coords.usrCoords[1], coords.usrCoords[2]]);
		
		linienende=10;
		if(liste.length>0) {
		    var sortierte_liste=liste.sort((a,b) => a[0].X()-b[0].X());
		    var i=0;
		    while (i<liste.length && sortierte_liste[i][0].X()<=coords.usrCoords[1]) { i++; };
		    
		    if (i<liste.length) {
			rechter_punkt=sortierte_liste[i][0];
			linienende=rechter_punkt.X();
			if (rechter_punkt.X()==p.X()) {
			    console.log("gleicher punkt",p.X());
			    board.removeObject(sortierte_liste[i][0]); 
			    board.removeObject(sortierte_liste[i][1]); 
			}                
		    }
		    if (i>0) {
			linker_punkt=sortierte_liste[i-1][0];
			if (linker_punkt.X()==p.X()) {
			    console.log("gleicher punkt",p.X());
			    board.removeObject(linker_punkt); 
			}
			linke_linie=sortierte_liste[i-1][1];
			linke_linie.point2.coords.usrCoords[1]=p.X();
			board.update();
		    }
		}
		l=board.create('segment', [[p.X(), p.Y()],[linienende, p.Y()]]);
		liste.push([p,l]);
		stackliste=liste.map(x=>"["+x[0].X()+","+x[0].Y()+"]").join();
		//=== Folgende Zeile nur für die Aufgabe ===
		//document.querySelector("[id*=jsxvar]").value=stackliste;
	    }
	},
	
	board = JXG.JSXGraph.initBoard('jxgbox1', {showCopyright: false, boundingbox: [-1,1.09,10,-0.09], axis: true});

    board.on('down', down);
});
